export default __webpack_public_path__ + "static/media/angpao-bg.2783416a.jpg";